import React from 'react';
import CategoryRow from '../CategoryRow';

const Book = () => (
  <CategoryRow title="Books" category="Books" exploreTo="/all-book-item" />
);

export default Book;
